import React, { useState, useEffect } from 'react';
import { API } from '../context/AuthContext';

const s = {
  page: { minHeight: '100vh', background: '#0a0a0a', color: '#fff', fontFamily: 'system-ui, -apple-system, sans-serif', display: 'flex', alignItems: 'center', justifyContent: 'center', padding: 24 },
  card: { background: '#111', border: '1px solid rgba(26,107,74,0.35)', borderRadius: 20, padding: '40px 36px', maxWidth: 420, width: '100%', textAlign: 'center', boxShadow: '0 0 60px rgba(26,107,74,0.12)' },
  badge: { width: 56, height: 56, borderRadius: 99, background: '#1a6b4a', color: '#fff', fontWeight: 800, fontSize: 20, display: 'flex', alignItems: 'center', justifyContent: 'center', margin: '0 auto 20px' },
  h1: { fontFamily: 'Georgia, serif', fontSize: 24, margin: '0 0 10px' },
  sub: { color: '#9b9b9b', fontSize: 14, lineHeight: 1.6, margin: '0 0 24px' },
  codeBox: { background: 'rgba(255,255,255,0.05)', border: '1px solid rgba(255,255,255,0.1)', borderRadius: 10, padding: '12px 16px', fontFamily: 'monospace', fontSize: 15, color: '#c9c9c9', marginBottom: 24, letterSpacing: '0.05em' },
  button: { display: 'block', width: '100%', boxSizing: 'border-box', padding: '15px', borderRadius: 10, border: 'none', background: '#1a6b4a', color: '#fff', fontWeight: 700, fontSize: 15, textDecoration: 'none', cursor: 'pointer' },
  note: { fontSize: 12, color: '#6b6b6b', marginTop: 18, lineHeight: 1.6 },
  error: { color: '#f87171', fontSize: 14, lineHeight: 1.6 },
};

export default function ClaimPatreon() {
  const [status, setStatus] = useState('loading'); // loading | valid | used | invalid
  const code = new URLSearchParams(window.location.search).get('code') || '';

  useEffect(() => {
    if (!code) { setStatus('invalid'); return; }
    fetch(`${API}/api/trade-room/patreon-gift-info/${code}`)
      .then((r) => r.json())
      .then((d) => {
        if (!d.valid) setStatus('invalid');
        else setStatus(d.already_used ? 'used' : 'valid');
      })
      .catch(() => setStatus('invalid'));
  }, [code]);

  const redeemUrl = `${API}/api/trade-room/claim-patreon/${code}`;

  return (
    <div style={s.page}>
      <div style={s.card}>
        <div style={s.badge}>CF</div>
        <h1 style={s.h1}>Your Trade Room gift</h1>

        {status === 'loading' && <p style={s.sub}>Checking your code…</p>}

        {status === 'invalid' && (
          <p style={s.error}>This link isn't valid. If you think that's a mistake, reply to your welcome email and I'll sort it out.</p>
        )}

        {(status === 'valid' || status === 'used') && (
          <>
            <p style={s.sub}>
              {status === 'used'
                ? "You've already claimed this — click below to head back to Patreon."
                : 'Claim free access on my $25 Patreon tier through the end of the year, for joining through BTCC.'}
            </p>
            <div style={s.codeBox}>{code}</div>
            <a href={redeemUrl} style={s.button}>
              {status === 'used' ? 'Go to Patreon' : 'Claim your free membership'}
            </a>
          </>
        )}

        <p style={s.note}>This code is tied to your account and can only be used once.</p>
      </div>
    </div>
  );
}
